import { render, staticRenderFns } from "./ExpandableCard.vue?vue&type=template&id=a3588d08&scoped=true&"
import script from "./ExpandableCard.vue?vue&type=script&lang=ts&"
export * from "./ExpandableCard.vue?vue&type=script&lang=ts&"
import style0 from "./ExpandableCard.vue?vue&type=style&index=0&id=a3588d08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3588d08",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VExpandTransition,VIcon,VSpacer})
